import { screenSmMin } from '@spotify-internal/encore-foundation';
import { cssSpacing } from "../../styles/index.mjs";
import { Type } from "../Type/index.mjs";
import styled from "../../styled-components.mjs";
export var BodyTitle = styled(Type).attrs({
  forwardedAs: 'h2',
  variant: 'celloCanon'
}).withConfig({
  displayName: "BodyTitle",
  componentId: "sc-19gs6oy-0"
})(["padding-block-end:", ";@media (min-width:", "){text-align:center;}"], cssSpacing('looser', '20px'), screenSmMin);